import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {ContentDetail, ContentMessageDetailType, ContentDetailMessage, ContentDetails} from '../../model/typings/content.types';
import {ContentStateService} from '../../services';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'cpui-content-details-pills',
  templateUrl: './content-details-pills.component.html',
  styleUrls: ['./content-details-pills.component.scss']
})
export class ContentDetailsPillsComponent implements OnInit, OnDestroy {
  activeContentDetail: ContentDetail;
  messageContentDetailSubscription: Subscription;

  @Input() contentTheme?: string;
  @Input() isTitleRight = false;
  @Input() isTitleFlipped = false;
  @Input() isExpanded = false;

  @Input() contentDetails: ContentDetails;
  @Input() titleCloseRoute: string;
  @Input() titleExpandRoute: string;
  @Input() titleCollapseRoute: string;

  constructor(private contentStateService: ContentStateService) {
  }

  ngOnInit() {
    this.messageContentDetailSubscription = this.contentStateService
      .activeMessageContentDetailObservable.subscribe(contentDetailMessage =>
        this.onActiveMessageContentDetailUpdate(contentDetailMessage));
  }

  ngOnDestroy() {
    if (this.messageContentDetailSubscription) {
      this.messageContentDetailSubscription.unsubscribe();
    }
  }

  onActiveMessageContentDetailUpdate(contentDetailMessage: ContentDetailMessage) {
    console.log(`CPUI - ContentDetailsPillsComponent.onActiveMessageContentDetailUpdate()`);
    this.activeContentDetail = contentDetailMessage ? contentDetailMessage.contentDetail : null;
  }

  activateContentDetail(contentDetail: ContentDetail) {
    console.log(`CPUI - ContentDetailsPillsComponent.activateContentDetail()`, contentDetail);

    const contentDetailMessage: ContentDetailMessage = (this.activeContentDetail === contentDetail) ? null : {
      id: `pillContent_${contentDetail.id}`,
      contentDetail,
      messageType: ContentMessageDetailType.AUTO_SMALL
    };

    this.contentStateService.setActiveMessageContentDetail(contentDetailMessage);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/content-details-pills/content-details-pills.component.ts